import { ConnectedRouter } from 'connected-react-router';
import React from 'react';
import { Redirect, Switch, useLocation } from 'react-router-dom';
import Antecipations from 'pages/Antecipations';
import InfoAntecipations from 'pages/Antecipations/components';
import Chat from 'pages/Chat';
import Collaborators from 'pages/Collaborators';
import CollaboratorForm from 'pages/Collaborators/CollaboratorForm';
import ConvocationsDetails from 'pages/ConvocationDetails';
import Convocations from 'pages/Convocations';
import CreateConvocation from 'pages/CreateConvocation';

import Dashboard from 'pages/Dashboard';
import Forgot from 'pages/Forgot';
import Notifications from 'pages/Notifications';
import Providers from 'pages/Providers';
import ProviderForm from 'pages/Providers/ProviderForm';
import Reports from 'pages/Reports';
import SignIn from 'pages/SignIn';
import TempAccompaniment from 'pages/TempAccompaniment';
import EvaluationForm from 'pages/EvaluationForm';
import Trip from 'pages/Trip';
import CreateTrip from 'pages/Trip/CreateTrip';
import PedidosFrete from 'pages/Transport/PedidosFrete';
import Trucker from 'pages/Trucker';
import TruckerData from 'pages/Trucker/TruckerData';
import TruckerForm from 'pages/Trucker/TruckerForm';
import Insurances from 'pages/Insurances';
import InsuranceForm from 'pages/Insurances/InsuranceForm';
import Profiles from 'pages/Profiles';
import ProfileForm from 'pages/Profiles/ProfileForm';
import FinanceiroDashboard from 'pages/Financeiro/Dashboard';
import ContasPagar from 'pages/Financeiro/ContasPagar';
import ContasReceber from 'pages/Financeiro/ContasReceber';
import ContaPagarForm from 'pages/Financeiro/ContasPagar/ContaPagarForm';
import ContaReceberForm from 'pages/Financeiro/ContasReceber/ContaReceberForm';
import Clientes from 'pages/Financeiro/Clientes';
import ClienteForm from 'pages/Financeiro/Clientes/ClienteForm';
import Naturezas from 'pages/Financeiro/Naturezas';
import NaturezaForm from 'pages/Financeiro/Naturezas/NaturezaForm';
import Fornecedores from 'pages/Financeiro/Fornecedores';
import FornecedorForm from 'pages/Financeiro/Fornecedores/FornecedorForm';
import Embarcadores from 'pages/Embarcadores';
import EmbarcadorForm from 'pages/Embarcadores/EmbarcadorForm';
import EmbarcadoresDashboard from 'pages/Embarcadores/Dashboard';
import Fretes from 'pages/Embarcadores/Fretes';
import FreteForm from 'pages/Embarcadores/Fretes/FreteForm';
import AcompanhamentoCarga from 'pages/Embarcadores/AcompanhamentoCarga';
import IniciarViagem from 'pages/IniciarViagem';
import history from 'services/history';
import Route from './Route';

// import Register from 'pages/Register';

function NoMatch() {
  const location = useLocation();

  return (
    <div>
      <h3>
        Página não encontrada - No match for <code>{location.pathname}</code>
      </h3>
    </div>
  );
}

export default function Routes() {
  return (
    <ConnectedRouter history={history}>
      <Switch>
        <Redirect exact path="/" to="/signin" />
        <Route path="/signin" exact component={SignIn} />
        <Route path="/forgot" exact component={Forgot} />
        <Route path="/temp/:id" component={TempAccompaniment} />
        <Route path="/rate/:id" component={EvaluationForm} />
        <Route path="/iniciar-viagem/:token" component={IniciarViagem} />
        {/* <Route path="/register" component={Register} isPrivate /> */}
        <Route path="/dashboard" exact component={Dashboard} isPrivate />
        <Route path="/trip/create" component={CreateTrip} isPrivate />
        <Route path="/trip/edit/:id" component={CreateTrip} isPrivate />
        <Route path="/trip" exact component={Trip} isPrivate />
        <Route path="/transport/pedidos-frete" exact component={PedidosFrete} isPrivate />
        <Route path="/embarcadores/dashboard" exact component={EmbarcadoresDashboard} isPrivate />
        <Route path="/embarcadores/list" exact component={Embarcadores} isPrivate />
        <Route path="/embarcadores/fretes" exact component={Fretes} isPrivate />
        <Route path="/embarcadores/fretes/new" component={FreteForm} isPrivate />
        <Route path="/embarcadores/fretes/edit/:id" component={FreteForm} isPrivate />
        <Route path="/embarcadores/fretes/view/:id" component={FreteForm} isPrivate />
        <Route path="/embarcadores/acompanhamento-carga" exact component={AcompanhamentoCarga} isPrivate />
        <Route path="/embarcadores/new" component={EmbarcadorForm} isPrivate />
        <Route path="/embarcadores/edit/:id" component={EmbarcadorForm} isPrivate />
        <Route path="/embarcadores/view/:id" component={EmbarcadorForm} isPrivate />
        <Route path="/trucker" exact component={Trucker} isPrivate />
        <Route path="/trucker/new" component={TruckerForm} isPrivate />
        <Route path="/trucker/edit/:id" component={TruckerForm} isPrivate />
        <Route path="/trucker_data" component={TruckerData} isPrivate />
        <Route path="/notifications" component={Notifications} isPrivate />
        <Route path="/collaborators" exact component={Collaborators} isPrivate />
        <Route path="/collaborators/new" component={CollaboratorForm} isPrivate />
        <Route path="/collaborators/edit/:id" component={CollaboratorForm} isPrivate />
        <Route path="/cargas" component={Convocations} isPrivate />
        <Route path="/antecipations" component={Antecipations} isPrivate />
        <Route
          path="/InfoAntecipations"
          component={InfoAntecipations}
          isPrivate
        />
        <Route
          path="/convocationDetails"
          component={ConvocationsDetails}
          isPrivate
        />

        <Route
          path="/createConvocation"
          component={CreateConvocation}
          isPrivate
        />
        <Route path="/providers" exact component={Providers} isPrivate />
        <Route path="/providers/new" component={ProviderForm} isPrivate />
        <Route path="/providers/edit/:id" component={ProviderForm} isPrivate />
        <Route path="/insurances" exact component={Insurances} isPrivate />
        <Route path="/insurances/new" component={InsuranceForm} isPrivate />
        <Route path="/insurances/edit/:id" component={InsuranceForm} isPrivate />
        <Route path="/profiles" exact component={Profiles} isPrivate />
        <Route path="/profiles/new" component={ProfileForm} isPrivate />
        <Route path="/profiles/edit/:id" component={ProfileForm} isPrivate />
        <Route path="/reports" component={Reports} isPrivate />
        <Route path="/chats" component={Chat} isPrivate />
        <Route path="/financeiro/dashboard" component={FinanceiroDashboard} isPrivate />
        <Route path="/financeiro/contas-pagar" exact component={ContasPagar} isPrivate />
        <Route path="/financeiro/contas-pagar/new" component={ContaPagarForm} isPrivate />
        <Route path="/financeiro/contas-pagar/edit/:id" component={ContaPagarForm} isPrivate />
        <Route path="/financeiro/contas-receber" exact component={ContasReceber} isPrivate />
        <Route path="/financeiro/contas-receber/new" component={ContaReceberForm} isPrivate />
        <Route path="/financeiro/contas-receber/edit/:id" component={ContaReceberForm} isPrivate />
        <Route path="/financeiro/clientes" exact component={Clientes} isPrivate />
        <Route path="/financeiro/clientes/new" component={ClienteForm} isPrivate />
        <Route path="/financeiro/clientes/edit/:id" component={ClienteForm} isPrivate />
        <Route path="/financeiro/clientes/view/:id" component={ClienteForm} isPrivate />
        <Route path="/financeiro/naturezas" exact component={Naturezas} isPrivate />
        <Route path="/financeiro/naturezas/new" component={NaturezaForm} isPrivate />
        <Route path="/financeiro/naturezas/edit/:id" component={NaturezaForm} isPrivate />
        <Route path="/financeiro/naturezas/view/:id" component={NaturezaForm} isPrivate />
        <Route path="/financeiro/fornecedores" exact component={Fornecedores} isPrivate />
        <Route path="/financeiro/fornecedores/new" component={FornecedorForm} isPrivate />
        <Route path="/financeiro/fornecedores/edit/:id" component={FornecedorForm} isPrivate />
        <Route path="/financeiro/fornecedores/view/:id" component={FornecedorForm} isPrivate />
        <Route path="*" component={NoMatch} />
      </Switch>
    </ConnectedRouter>
  );
}
